import React from "react";
import { Star } from "lucide-react";
import { marqueeReviews } from "../mock";

export default function ReviewsMarquee() {
  const items = [...marqueeReviews, ...marqueeReviews, ...marqueeReviews];
  return (
    <section className="bg-[#1a1a1a] text-[#FBF8F4] py-6 overflow-hidden border-y border-[#C9A961]/30">
      <div className="container-y px-5 md:px-8 mb-3 flex items-center justify-center gap-3">
        <div className="star-row flex items-center gap-1">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={14} fill="#C9A961" color="#C9A961" />
          ))}
        </div>
        <p className="font-sans-y text-[12px] tracking-[0.2em] uppercase">
          100+ Real Customers, Real Reviews
        </p>
      </div>
      <div className="marquee-track">
        {items.map((t, i) => (
          <span
            key={i}
            className="font-sans-y text-[13px] md:text-[14px] px-8 whitespace-nowrap flex items-center"
          >
            <span className="text-[#C9A961] mr-8">✦</span>
            {t}
          </span>
        ))}
      </div>
    </section>
  );
}
